import { T } from '@tribeplatform/react-components/i18n'

import type { TableCounterProps } from './types.js'

export const MembersCounter = ({
  matchedCount,
  totalCount,
}: TableCounterProps) => {
  return (
    <div className="flex items-center space-s-1">
      {totalCount === matchedCount ? (
        <span className="font-medium">
          <T
            defaultMessage="{members_count, plural, zero {No {MEMBERS}} one {# {MEMBER}} other {# {MEMBERS}}}"
            id="Generics.Members.Plural"
            values={{
              members_count: totalCount,
            }}
          />
        </span>
      ) : (
        <span>
          <T
            defaultMessage="<bold>{matched_count, plural, one {# {MEMBER}} other {# {MEMBERS}}} matched</bold> of {total_count, number}"
            id="Admin.MembersList.TableCounter"
            values={{
              matched_count: matchedCount,
              total_count: totalCount,
              bold: chunks => <span className="font-medium">{chunks}</span>,
            }}
          />
        </span>
      )}
    </div>
  )
}
